import styled from 'styled-components';

export const ItemRow = styled.button`
  width: 100%;
  height: 32px;
  border: 0;
  border-radius: 8px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props) =>
    props.$isSelected ? '#f6f9ff' : 'transparent'};
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.colors.highClearGray};
  }
`;

export const ItemLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const ItemLabel = styled.span`
  color: ${(props) =>
    props.$isSelected ? props.theme.colors.darkGray : props.theme.colors.davysGrey};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
`;

export const ItemRight = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
